import { motion } from "framer-motion";
import { FaBullseye, FaEye } from "react-icons/fa";

const MissionVision = () => {
  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="container-custom">

        {/* Section Header */}

        <div className="text-center max-w-3xl mx-auto mb-16">

          <span className="text-[#F59E0B] uppercase tracking-widest font-semibold">
            Mission & Vision
          </span>

          <h2 className="text-4xl lg:text-5xl font-bold text-[#082B57] mt-4">
            Driven By Purpose,
            <span className="text-[#F59E0B]"> Inspired By Vision</span>
          </h2>

          <p className="text-gray-600 mt-6 leading-8">
            Our mission and vision guide every project we undertake,
            helping us create lasting value for clients and communities.
          </p>

        </div>

        {/* Cards */}

        <div className="grid lg:grid-cols-2 gap-8">

          {/* Mission */}

          <motion.div
            initial={{ opacity: 0, x: -80 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="relative bg-slate-50 rounded-3xl p-10 border border-gray-100 shadow-lg hover:shadow-2xl transition-all duration-300"
          >

            <div className="w-20 h-20 rounded-2xl bg-[#082B57] flex items-center justify-center text-white text-3xl">
              <FaBullseye />
            </div>

            <h3 className="text-3xl font-bold text-[#082B57] mt-8">
              Our Mission
            </h3>

            <p className="text-gray-600 leading-8 mt-6">
              To deliver innovative, reliable and high-quality
              construction, development and property solutions
              that exceed client expectations while maintaining
              the highest standards of professionalism,
              transparency and integrity.
            </p>

            <div className="mt-8 w-20 h-1 bg-[#F59E0B] rounded-full"></div>

          </motion.div>

          {/* Vision */}

          <motion.div
            initial={{ opacity: 0, x: 80 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="relative bg-[#082B57] rounded-3xl p-10 shadow-lg hover:shadow-2xl transition-all duration-300"
          >

            <div className="w-20 h-20 rounded-2xl bg-[#F59E0B] flex items-center justify-center text-white text-3xl">
              <FaEye />
            </div>

            <h3 className="text-3xl font-bold text-white mt-8">
              Our Vision
            </h3>

            <p className="text-white/80 leading-8 mt-6">
              To become one of the most trusted construction and
              development companies by delivering landmark projects,
              creating sustainable growth opportunities and building
              long-term relationships with clients, partners and
              communities.
            </p>

            <div className="mt-8 w-20 h-1 bg-[#F59E0B] rounded-full"></div>

          </motion.div>

        </div>

      </div>
    </section>
  );
};

export default MissionVision;